import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import { api_url } from "../../../js_assets/ConfigApp";
import { GetApi, PostApi } from "../../../js_assets/Network";
import { getParameterByName } from "../../../js_assets/getParameterByName";

import Dialog from "@material-ui/core/Dialog";

import Grid from "@material-ui/core/Grid";

import DialogTitle from "@material-ui/core/DialogTitle";
import axios from "axios";
import AppAdminContainer from "../AppAdminContainer";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  input: {
    paddingRight: 10,
    flex: 1,
  },
  divwidth: {
    width: "60%",
  },
  btn_login: {
    color: "white",
    padding: "2px 1px",
    border: "none",
    cursor: "pointer",
    width: "250px",
    opacity: "0.9",
    borderRadius: "3px",
  },
  btn_Resetfrom: {
    color: "white",
  },
});

class AdminCpConsulting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading_Save: false,
      offer_Id: 0,
      successmessage: false,
      Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
    };
  }

  componentDidMount() {
    let offer_Id = getParameterByName("offer_Id");

    if (offer_Id !== null) {
      if (offer_Id === "New") {
        //console.log("it new ")
      } else {
        //console.log("it number " + offer_Id)

        axios
          .get(`${api_url}/api/offer/GetOffer/${offer_Id}`)
          .then((result) => {
            //console.log(result.data);

            this.setState({ offer_Id: result.data.offer_Id });
            this.refs.offer_StoreName.value = result.data.offer_StoreName;
            this.refs.offer_Code.value = result.data.offer_Code;
            this.refs.offer_Description.value = result.data.offer_Description;
            this.refs.offer_Image.value = result.data.offer_Image;
            this.refs.offer_Date.value = result.data.offer_Date;
            this.refs.code_Remaining.value = result.data.code_Remaining;
          });
      }
    }
  }

  Save_Offer = () => {
    this.setState({ loading_Save: true });

    const { Admin_Info } = this.state;

    let consulting_Offer_model = {
      consulting_Offer_Code_Text: this.refs.consulting_Offer_Code_Text.value,
    };

    PostApi(
      `/api/Admin/Save_Consulting_Offer_Code/${Admin_Info.admin_Id}`,
      consulting_Offer_model,
      Admin_Info.jwT_Token_Admin
    ).then(() => {
      this.setState({ loading_Save: false, successmessage: true });
      //console.log("it update ")
    });
  };

  MakeUUID = (length) => {
    var result = "";
    var characters = "-abcdefghijklmnopqrstuvwxyz1234567890";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  get_consulting_Offer_Code_Text = () => {
    let code = this.MakeUUID(4) + "-" + this.MakeUUID(4);

    this.refs.consulting_Offer_Code_Text.value = code.trim();
  };

  handlClosesuccessmessage = () => {
    this.setState({ successmessage: false });
  };

  render() {
    const { classes } = this.props;
    const { loading_Save } = this.state;

    return (
      <AppAdminContainer Title={"العروض"}>
        <Dialog
          open={this.state.successmessage}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handlClosesuccessmessage}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            <div className="alertIcon">
              ✔️ <label>تم حفظ </label>
            </div>
          </DialogTitle>
        </Dialog>

        <Grid
          style={{ paddingTop: "7%", paddingBottom: "30px" }}
          justify="center"
          alignItems="center"
          container
          spacing={8}
        >
          <div className="container">
            <span> اكتب الكود</span>
            <input

              placeholder=" اكتب الكود"
              name="consulting_Offer_Code_Text"
              ref="consulting_Offer_Code_Text"
              required
            />

            <Grid
              style={{ paddingTop: "20px" }}
              justify="center"
              alignItems="center"
              container
              spacing={8}
            >
              <button
                className={classes.btn_login}
                variant="contained"
                type="Submit"
                color="secondary"
                onClick={() => this.get_consulting_Offer_Code_Text()}
              >
                <label>توليد كود عشوائي</label>
              </button>
            </Grid>

            <Grid
              style={{ paddingTop: "100px" }}
              justify="center"
              alignItems="center"
              container
              spacing={8}
            >
              <button
                variant="contained"
                type="Submit"
                color="primary"
                onClick={() => this.Save_Offer()}
                className={classes.btn_login}
              >
                {loading_Save === true ? (
                  <CircularProgress color={"secondary"} />
                ) : (
                  <label>حفظ</label>
                )}
              </button>
            </Grid>
          </div>
        </Grid>
      </AppAdminContainer>
    );
  }
}
AdminCpConsulting.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AdminCpConsulting);
